var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_658_19423)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 0H22C23.1046 0 24 0.895431 24 2V22C24 23.1046 23.1046 24 22 24H2C0.89543 24 0 23.1046 0 22V2C0 0.89543 0.895431 0 2 0ZM7.58735 9.28252H4.37968V19.6032H7.58735V9.28252ZM7.84302 6.01119C7.84302 4.98552 7.00968 4.15219 5.98402 4.15219C5.73684 4.14751 5.49121 4.19215 5.26149 4.28351C5.03176 4.37486 4.82256 4.5111 4.6461 4.68425C4.46964 4.8574 4.32947 5.06399 4.23378 5.29194C4.13809 5.51989 4.08881 5.76463 4.08881 6.01186C4.08881 6.25908 4.13809 6.50382 4.23378 6.73177C4.32947 6.95972 4.46964 7.16632 4.6461 7.33947C4.82256 7.51262 5.03176 7.64885 5.26149 7.7402C5.49121 7.83156 5.73684 7.8762 5.98402 7.87152C7.00968 7.87152 7.84302 7.03786 7.84302 6.01119ZM12.676 9.28219H9.59935L9.59902 9.28252V19.6032H12.804V14.4979C12.804 13.1515 13.0604 11.8479 14.7294 11.8479C16.374 11.8479 16.396 13.3875 16.396 14.5842V19.6032H19.6017V13.9425C19.6017 11.1635 19.0017 9.02586 15.7537 9.02586C14.1934 9.02586 13.147 9.88119 12.7187 10.6925H12.676V9.28219Z",
    fill: "#3532F4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_658_19423"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIn);
export default __webpack_public_path__ + "static/media/In.2ba3fc4102d17e606797f6009fcdb1e7.svg";
export { ForwardRef as ReactComponent };